import { Injectable } from '@angular/core';
import { BaseEntityReloadResolver2 } from './resolver.helper';
import { Store } from '@ngrx/store';
import { State } from '../State';
import {
    getChartOfAccountsFetched,
    getChartOfAccountsLatestUpdatedAt,
} from '../State/selectors/chartOfAccount.selectors';
import { ChartOfAccountActionTypes } from '../State/actions/chartOfAccount.actions';

@Injectable({
    providedIn: 'root',
})
export class ChartOfAccountResolver extends BaseEntityReloadResolver2 {
    constructor(store: Store<State>) {
        super(getChartOfAccountsFetched, getChartOfAccountsLatestUpdatedAt , ChartOfAccountActionTypes.LoadAll, store);
    }
}
